"use strict";

function ready(callbackFunc) {
  if (document.readyState !== 'loading') {
    // Document is already ready, call the callback directly
    callbackFunc();
  } else if (document.addEventListener) {
    // All modern browsers to register DOMContentLoaded
    document.addEventListener('DOMContentLoaded', callbackFunc);
  } else {
    // Old IE browsers
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        callbackFunc();
      }
    });
  }
}

ready(function () {
  console.log('Invigorate'); // TODO rewrite typewriter to avoid memory leak

  var charIndex = -1;
  var wordIndex = -1;
  var direction = 1;
  var words = ['Celiac Disease', 'Lupus', 'Multiple Sclerosis', 'Psoriasis', 'Rheumatoid Arthritis', 'Anxiety', 'Brain Fog', 'Fatigue', 'Insomnia', 'Migraines', 'Stress']; // shuffle( words );
  // const words = [
  // 	'eins',
  // 	'zwei',
  // 	'drei',
  // ];

  words.push('health');
  var word = null;
  var speed = 50;
  var pauseTime = 2000;
  var textControlOf = document.getElementById('control-of');
  typeWriter();

  function typeWriter() {
    if (charIndex < 0) {
      textControlOf.textContent = '';
      wordIndex++; // word = words[ wordIndex % words.length ];

      word = words[wordIndex];
      charIndex = 0;
      direction = 1;
    }

    if (charIndex < word.length) {
      if (direction > 0) {
        textControlOf.textContent += word.charAt(charIndex);
      } else {
        textControlOf.textContent = textControlOf.textContent.slice(0, -1);
      }

      charIndex += direction;
      setTimeout(typeWriter, speed);
    } else {
      if (wordIndex >= words.length - 1) {
        return null;
      }

      direction = -1;
      charIndex += direction;
      setTimeout(typeWriter, pauseTime);
    }
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var _ref = [a[j], a[i]];
      a[i] = _ref[0];
      a[j] = _ref[1];
    }

    return a;
  }
});